// extracted by mini-css-extract-plugin
export var wordContainer = "_q0-0";